/* agb-micromap-kzerosf-override.js
 * ---------------------------------------------------------------------------
 * Swaps the Micro MAP(TM) Back Panel CANVAS layer to a custom render for the
 * K-Zero SF plate carrier in MULTICAM ONLY (gear builder).
 *
 * Why a separate file instead of editing the bundle: EU/IL ship a pre-built
 * agb-uipack.min.js compiled from sources that are NOT in this repo, so editing
 * their source + rebuilding would REGRESS the live builder. This add-on never
 * touches the bundle -- after the builder's "images" module loads it reaches in
 * via getProductLayerMap() and re-points one entry at runtime. (ROW does the
 * same change directly in agb-images.js, which it can rebuild from source.)
 *
 * Scope (identical to the ROW source edit):
 *   - base handle 'k-zero-sf-plate-carrier' ONLY ('-copy' clone untouched).
 *   - the MULTICAM entry ONLY -- matched BY ITS CURRENT IMAGE ('Micro_map_mtc.webp'),
 *     so it works regardless of colour-label language (ROW/EU English 'Multicam',
 *     IL Hebrew). 'Micro_map_mtcb.webp' (Multicam Black) is deliberately NOT matched.
 *   - CANVAS layer only; the suggestion-card thumbnail is unaffected (it uses the
 *     product's featured_image, not this map).
 * Fails safe: if the module / map / entry isn't present, it simply no-ops.
 * ---------------------------------------------------------------------------
 */
(function () {
  'use strict';

  // Public Shopify Files URL -- cdn.shopify.com is public, so the same URL loads
  // on every store. If a store later hosts its own copy, change this one line.
  var NEW_URL = 'https://cdn.shopify.com/s/files/1/0526/4001/files/k_zero_sf_multicam_micromap.webp';
  var BASE_HANDLE = 'k-zero-sf-plate-carrier';
  var OLD_MULTICAM_RE = /Micro_map_mtc\.webp/i; // matches Multicam, NOT 'mtcb' (Multicam Black)

  var done = false;

  function apply() {
    if (done) return true;
    try {
      if (!(window.AGB && typeof window.AGB.require === 'function')) return false;
      var images = window.AGB.require('images');
      if (!images || typeof images.getProductLayerMap !== 'function') return false;
      var map = images.getProductLayerMap();
      // Accessories live under map.byHandle (resolveUrl reads MAPPED_PRODUCT_LAYER_MAP.byHandle);
      // fall back to the map root for any build that omits the wrapper.
      var root = (map && map.byHandle) || map;
      var mm = root && root['micro-map'];
      var node = mm && mm.back && mm.back.byBase && mm.back.byBase[BASE_HANDLE];
      if (!node) return false;
      var hit = false;
      Object.keys(node).forEach(function (k) {
        if (typeof node[k] === 'string' && OLD_MULTICAM_RE.test(node[k])) {
          node[k] = NEW_URL;
          hit = true;
        }
      });
      if (hit) { done = true; return true; }
      return false; // map present but the Multicam entry isn't ready yet -- retry
    } catch (e) { return false; }
  }

  // The "images" module registers only when the builder lazy-loads Step 2's
  // uipack, so poll. Bail early on non-builder pages (AGB never appears).
  var n = 0, sawAgb = false;
  (function retry() {
    if (apply()) return;
    if (window.AGB && typeof window.AGB.require === 'function') sawAgb = true;
    if (!sawAgb && n > 30) return;          // ~6s with no AGB -> not a builder page
    if (n++ < 600) setTimeout(retry, 200);  // builder page: keep trying for Step 2
  })();
})();
